"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaType = void 0;
var MediaType;
(function (MediaType) {
    MediaType[MediaType["PHOTO"] = 'PHOTO'] = "PHOTO";
    MediaType[MediaType["VIDEO"] = 'VIDEO'] = "VIDEO";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
//# sourceMappingURL=media-item.js.map